import React from 'react';

function Assistance() {
  return (
    <body>
    <h1>User Assistance</h1>


     <p>To cancel subscriptions please visit the subscription page on either the app store or the play store.</p>
     <p><b> Email adress:</b>  support@createawesomeapps.tn</p>
    


    </body>
  );
}

export default Assistance;
